import React, { useRef, useState } from "react";
import ModalLoadEarned from "../Components/modalLoadEarned";
import { alert, stateAlert } from "../Store/simulate/actions";
import { useDispatch } from "react-redux";
import { ButtonsModalActions } from "./ButtonsModalActions";

const ButtonsSectionRV = ({
  setIsLoading,
  openModalActionsRV,
  activeButton,
  handleButtonAction,
  reloadQuotes,
}) => {
  const dispatch = useDispatch();
  const [openUploadXML, setOpenUploadXML] = useState(false);
  const inputLoadRequestFileRef = useRef(null);

  // Load Rem Promedio File
  const inputLoadRemPromRef = useRef(null);

  const handleLoadRemPromFile = (files) => {
    if (files.length !== 0) {
      const requestFile = files[0];
      saveRemPromValueOfFiles(requestFile);
    }
    inputLoadRemPromRef.current.value = null;
  };

  const saveRemPromValueOfFiles = (requestFile) => {
    const includesXML = requestFile.name.includes("xls");

    if (!includesXML) {
      dispatch(stateAlert(true));
      dispatch(
        alert({
          type: "error",
          title: "Archivo inválido",
          message: "El tipo de archivo seleccionado no es válido.",
        })
      );
      setTimeout(() => {
        dispatch(stateAlert(false));
      }, 4000);
      return;
    }
    if (includesXML) {
      setIsLoading(true);

      setTimeout(() => {
        setIsLoading(false);
        dispatch(stateAlert(true));
        dispatch(
          alert({
            type: "success",
            title: "¡Remuneraciones Promedio cargadas!",
            message:
              "Las remuneraciones promedio se han cargado correctamente.",
          })
        );
        setTimeout(() => {
          dispatch(stateAlert(false));
        }, 4000);
      }, 1500);
    }
  };

  return (
    <>
      <div className="sectionTable__actionButtons">
        <button
          className="btn is-small"
          disabled={!activeButton || !activeButton.rem}
          onClick={() => inputLoadRemPromRef.current.click()}
        >
          Cargar Rem Promedio
        </button>
        <button
          className="btn is-small"
          disabled={!activeButton || !activeButton.xmlMeller}
          onClick={() => handleButtonAction()}
        >
          Generar XML Meller
        </button>
        <button className="btn is-small" onClick={() => setOpenUploadXML(true)}>
          Cargar XML ganadas
        </button>

        <button
          className="btn is-small"
          disabled={!activeButton || !activeButton.excel}
        >
          Descargar Excel
        </button>
      </div>
      <input
        type="file"
        ref={inputLoadRemPromRef}
        accept=".xls"
        className="hide-input"
        onChange={(e) => handleLoadRemPromFile(e.target.files)}
      />
      <ButtonsModalActions
        openModalActionsRV={openModalActionsRV}
        inputLoadRequestFileRef={inputLoadRequestFileRef}
        inputLoadRemPromRef={inputLoadRemPromRef}
        setOpenUploadXML={setOpenUploadXML}
      />
      <ModalLoadEarned
        open={openUploadXML}
        close={() => setOpenUploadXML(false)}
        reloadQuotes={reloadQuotes}
      />
    </>
  );
};

export default ButtonsSectionRV;